module.exports = __webpack_public_path__ + "img/puzzlePiece_p.cc80e669.svg";